import styled from 'styled-components';

export const ControllWrapper = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
  .offline::after,
  &.loading::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 3;
  }

  .offline::before {
    content: '${(props) => props.$status}';
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    text-transform: uppercase;
    font-size: 24px;
    font-weight: normal;
    width: 240px;
    height: 50px;
    text-align: center;
    margin: -25px 0 0 -120px;
    z-index: 11;
  }
  &.loading::after {
    background: #393e44 url(/images/loader.svg) no-repeat 50%;
  }
`;
export const Media = styled.div`
  width: 500px;
`;

export const ControlPanel = styled.div`
  width: 450px;
  position: relative;
`;

export const Block = styled.div`
  box-sizing: border-box;
  position: absolute;
  width: 265px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  background-color: rgba(0, 0, 0, 0.9);
  top: 50px;
  right: 0px;
  padding: 15px;
  z-index: 9;
`;

export const Notification = styled.div`
  padding: 30px 40px;
  box-sizing: border-box;
  background: #fff;
  position: absolute;
  width: 430px;
  left: 0;
  top: 100px;
`;
export const WarningNotification = styled(Notification)`
  display: flex;
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 430px;
  color: #adafb1;
  font-size: 15px;
  border-style: hidden;
  p {
    font-size: 13px;
    color: white;
  }
  thead > tr > th:first-child {
    text-align: left;
    padding-left: 0;
  }
  tbody > tr:first-child > td:first-child {
    vertical-align: text-top;
    text-align: left;
    padding-top: 5px;
    padding-left: 0;
    border-bottom: 0;
  }
  td,
  th {
    padding: 0 10px;
    text-align: right;
    height: 25px;
    border: 1px solid #4c5056;
  }
`;

export const Table2 = styled.table`
  border-collapse: collapse;
  width: 100%;
  color: #adafb1;
  font-size: 15px;
  border-style: hidden;
  td,
  th {
    box-sizing: border-box;
    height: 26px;
    position: relative;
    padding: 3px;
    font-size: 15px;
    line-height: normal;
    text-align: right;
    border: 1px solid #4c5056;
    border-bottom: 0;
  }
  td {
    position: relative;
  }
  .bill,
  .coin {
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -14px;
    width: 30px;
    height: 28px;
    background: url(/images/coin2.png) no-repeat 2px 50%;
    background-size: contain;
  }
  .bill {
    background-image: url(/images/bill2.png);
  }
  .coin {
  }
  img {
    position: absolute;
    max-height: 100%;
    height: 20px;
    width: auto;
    top: 50%;
    margin-top: -10px;
    left: 10px;
  }
  .total {
    text-align: left;
    vertical-align: top;
  }
  .warning-medium {
    color: #ad963f;
  }
  .warning-hight {
    color: #ad4143;
  }
`;

export const RackWrapper = styled(ControllWrapper)`
  display: flex;
`;
